import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { i18nFilter } from "app/filters/i18nFilter";
import { ExcelDownload } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/Components/ExcelDownload";
import { PngDownload } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/Components/PngDownload";
import { ORGANIC_PAID } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/Helpers/SearchOverviewGraphConfig";
import { searchOverviewContext } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/SearchOverviewGraphContext";
import { useContext, useMemo } from "react";
import StyledBoxSubtitle from "pro-features/styled components/StyledBoxSubtitle/src/StyledBoxSubtitle";
import {
    MMXAlertWrapper,
    SearchOverviewGraphHeaderStyle,
    StyledHeaderTitle,
    UtilitiesContainer,
    UtilitiesContainerWrapper,
} from "./StyledComponents";
import { MMXAlertWithPlainTooltip } from "app/components/MMXAlertWithPlainTooltip";
import dayjs from "dayjs";
import DurationService from "app/services/DurationService";
import { swSettings } from "app/common/services/swSettings";
import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import CountryService from "app/services/CountryService";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { allTrackers } from "app/services/track/track";

export const GraphTabHeader = (props) => {
    const { isMobileWeb, queryParams, params } = props;
    const { duration, webSource, country } = params;
    const { chartRef, selectedMetricTab, category } = useContext(searchOverviewContext);
    const tooltip = isMobileWeb
        ? "analysis.source.search.overview.analysis.mobile.tooltip"
        : "analysis.source.search.overview.analysis.tooltip";
    const durationObject = DurationService.getDurationData(duration);
    const newMMXAlgoStartData = swSettings.current.resources.NewAlgoMMX;
    const isShowMMXAlertBell =
        webSource !== devicesTypes.DESKTOP &&
        durationObject.raw.from.isBefore(dayjs(newMMXAlgoStartData)) &&
        durationObject.raw.to.isAfter(dayjs(newMMXAlgoStartData));

    const subtitleFilters = useMemo(
        () => [
            {
                filter: "date",
                value: {
                    from: durationObject.raw.from.valueOf(),
                    to: durationObject.raw.to.valueOf(),
                    useRangeDisplay:
                        duration !== "28d" &&
                        durationObject.raw.from.format("YYYY-MM") !== durationObject.raw.to.format("YYYY-MM"),
                },
            },
            {
                filter: "country",
                countryCode: country,
                value: CountryService.getCountryById(country)?.text,
            },
            {
                filter: "webSource",
                value: webSource,
            },
        ],
        [durationObject, country, webSource, duration],
    );

    const pngTracking = () => {
        allTrackers.dispatchTrackEvent(
            "Download",
            "submit-ok",
            `Over Time Graph/${selectedMetricTab.name}/Png`,
        );
    }

    return (
        <SearchOverviewGraphHeaderStyle marginBottom={0}>
            <FlexColumn>
                <StyledHeaderTitle>
                    <BoxTitle tooltip={i18nFilter()(tooltip)}>
                    <I18n>website.analysis.search.overview.search.performance.over.time.title</I18n>
                        {isShowMMXAlertBell && (
                            <MMXAlertWrapper>
                                <MMXAlertWithPlainTooltip />
                            </MMXAlertWrapper>
                        )}
                    </BoxTitle>
                    <StyledBoxSubtitle>
                        <BoxSubtitle filters={subtitleFilters} />
                    </StyledBoxSubtitle>
                </StyledHeaderTitle>
            </FlexColumn>
            <UtilitiesContainerWrapper>
                <UtilitiesContainer>
                    <PngDownload
                        metricName={selectedMetricTab.name}
                        chartRef={chartRef}
                        tracking={pngTracking}
                    />
                    {category.id === ORGANIC_PAID && (
                        <ExcelDownload
                            metricName={selectedMetricTab.name}
                            queryParams={queryParams}
                        />
                    )}
                </UtilitiesContainer>
            </UtilitiesContainerWrapper>
        </SearchOverviewGraphHeaderStyle>
    );
};
